import { EyeIcon, EyeOffIcon, LockClosedIcon } from "../../shared/Icons";
import { ReactComponent as ManageColumns } from "../../shared/assets/manage-columns.svg";
import { themeAtom } from "../../shared/atoms";
import { PerfTableCol } from "../models/vessel-details.models";
import { Popover, Transition } from "@headlessui/react";
import { useAtomValue } from "jotai";
import { Fragment } from "react";
import { twMerge } from "tailwind-merge";

// TODO improve interface and enable any option to be disabled, not just speed (remove speedOptionName func param, replace with option param: enabled)
export function PerfManageColsMenu(
  count: number,
  columns: PerfTableCol[],
  visibleColumns: string[],
  toggleColumn: (accessor: string) => void,
  speedOptionName: string,
) {
  const theme = useAtomValue(themeAtom);

  return () => {
    return (
      <div className="max-w-sm px-4 pb-2 pr-0">
        <Popover className="relative">
          {({ open }) => (
            <>
              <Popover.Button
                className={twMerge(
                  open ? "text-white" : "text-white/90",
                  "group inline-flex items-center rounded-md border px-4 py-2 text-sm focus:outline-none",
                  theme.vesselDetails.menuBtnBorder,
                  theme.vesselDetails.textBtn,
                  theme.uwhcAssistant.border,
                )}
              >
                <ManageColumns className={twMerge("mr-2 h-6 w-5", theme.vesselDetails.textBtn)} />
                <p className={theme.vesselDetails.textBtn}>
                  Manage column
                  {count > 0 && <>({count})</>}
                </p>
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute z-10 mt-1 h-auto w-52 px-4 shadow-lg sm:px-0" style={{ right: 0 }}>
                  <div
                    className={twMerge(
                      "rounded-lg border shadow-lg focus:outline-none",
                      theme.home.tailwind.panelBackground,
                      theme.uwhcAssistant.border,
                      theme.uwhcAssistant.text,
                    )}
                  >
                    <div className="relative">
                      <p className={twMerge("border-b px-4 py-2 text-sm font-semibold", theme.uwhcAssistant.border)}>
                        Shown in table
                      </p>
                      <ul>
                        {columns.map(
                          (column) =>
                            visibleColumns.includes(column.accessor) && (
                              <li className="flex flex-row items-stretch" key={column.accessor}>
                                {column.accessor === speedOptionName ? (
                                  <div className="flex w-full flex-row items-stretch justify-start whitespace-nowrap px-3 py-3 text-sm">
                                    <LockClosedIcon className="h-5 w-5" />
                                    <p className="flex-1 pl-2 text-start">{column.header} </p>
                                  </div>
                                ) : (
                                  <button
                                    className={twMerge(
                                      "flex w-full flex-row items-stretch justify-start whitespace-nowrap px-3 py-3 text-sm",
                                      theme.vesselDetails.hover,
                                    )}
                                    onClick={() => toggleColumn(column.accessor)}
                                  >
                                    <EyeIcon className="h-5 w-5" style={{ padding: "0 2px 0 2px" }} />
                                    <p className="flex-1 pl-2 text-start">{column.header}</p>
                                  </button>
                                )}
                              </li>
                            ),
                        )}
                      </ul>
                      <p className={twMerge("border-t px-4 py-2 text-sm font-semibold", theme.uwhcAssistant.border)}>
                        Hidden in table ({columns.length - visibleColumns.length} items)
                      </p>
                      <ul className={`${visibleColumns.length === 0 ? "border-t-2" : ""}`}>
                        {columns.map(
                          (column) =>
                            !visibleColumns.includes(column.accessor) && (
                              <li
                                className={twMerge("flex flex-row items-stretch", theme.vesselDetails.hover)}
                                key={column.accessor}
                              >
                                <button
                                  className="flex w-full flex-row items-stretch justify-start whitespace-nowrap px-3 py-3 text-sm"
                                  onClick={() => toggleColumn(column.accessor)}
                                >
                                  <EyeOffIcon className="h-5 w-5" style={{ padding: "0 2px 0 2px" }} />
                                  <p className="flex-1 pl-2 text-start">{column.header} </p>
                                </button>
                              </li>
                            ),
                        )}
                      </ul>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    );
  };
}
